import Icon from '@ant-design/icons';
import React from 'react';

/** 主题切换：空心圆心 + 8 条放射短线（与文字同色的浅色模式太阳） */
const ThemeSunSvg: React.FC = () => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" aria-hidden="true" focusable="false" style={{ display: 'block' }}>
    <circle cx="12" cy="12" r="2.8" fill="none" stroke="currentColor" strokeWidth="1.2" />
    <path
      d="M12 7.8V2.5M14.97 9.03L18.71 5.29M16.2 12H21.5M14.97 14.97L18.71 18.71M12 16.2V21.5M9.03 14.97L5.29 18.71M7.8 12H2.5M9.03 9.03L5.29 5.29"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
  </svg>
);

export const ThemeSunIcon: React.FC<{ className?: string }> = ({ className }) => (
  <Icon component={ThemeSunSvg} className={className} />
);
